import { Dashboard } from 'layouts/authenticated/pages/dashboard'
import { DashboardTwo } from 'layouts/authenticated/pages/dashboard'
import { Fegli } from 'layouts/authenticated/pages/dashboard'
import DataTables from 'layouts/applications/data-tables'
import { Documents } from 'layouts/applications/documents'
import { Benefits } from 'layouts/applications/Benefits'
import { UsersList } from 'admin/UsersList'
import { UserAudit } from 'admin/UserAudit'
import { LeadsList } from 'admin/LeadsList'
import { AgencyList } from 'admin/AgencyList'
import { DesignReference } from 'admin/DesignReference'
import { NewComponentReference } from 'admin/NewComponentReference'
import { Calculations } from 'admin/Calculations'
import { Buyout } from 'admin/Buyout'
import { CalcCheck } from 'admin/CalcCheck'
import QuickSheet from 'admin/QuickSheet'
import { ShowUser } from 'admin/ShowUser'
import QuickSheetNew from 'admin/QuickSheetNew'
import TSP from 'layouts/applications/tsp/TSP'
import MasterInputs from 'admin/MasterInputs'
import NewDashboard from 'layouts/authenticated/pages/newdash'
import Profile from 'layouts/authenticated/pages/profile'
import NewProfile from 'layouts/authenticated/pages/newprofile'
import { NewDocuments } from 'layouts/authenticated/pages/documents'
import { NewBenefits } from 'layouts/authenticated/pages/Benefits'
import NewTsp from 'layouts/authenticated/pages/tsp/NewTsp'
import NewFegli from 'layouts/authenticated/pages/fegli'
import Resources from 'layouts/authenticated/pages/resources'
import FinancialFrameworkCreator from 'admin/FinancialFrameworkCreator'
import {
  AccountBox,
  AddBox,
  Article,
  Assessment,
  DashboardRounded,
  Favorite,
  Source,
  SupervisorAccount,
} from '@mui/icons-material'
import GraphsCheck from 'admin/GraphsCheck'

const routes = [
  {
    type: 'collapse',
    name: 'Dashboard',
    key: 'dashboard',
    route: '/dashboard',
    component: <NewDashboard />,
    icon: <DashboardRounded />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'Profile',
    key: 'profile',
    route: '/profile',
    component: <NewProfile />,
    icon: <AccountBox />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'Documents',
    key: 'documents',
    route: '/documents',
    component: <NewDocuments />,
    icon: <Article />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'TSP',
    key: 'tsp',
    route: '/tsp',
    component: <NewTsp />,
    icon: <Assessment />,
    noCollapse: true,
    requiresAgency: true,
  },
  {
    type: 'collapse',
    name: 'Benefits',
    key: 'benefits',
    route: '/benefits',
    component: <NewBenefits />,
    icon: <AddBox />,
    noCollapse: true,
    requiresAgency: true,
  },
  {
    type: 'collapse',
    name: 'Life Insurance',
    key: 'life-insurance',
    route: '/life-insurance',
    component: <NewFegli />,
    icon: <Favorite />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'Resources',
    key: 'resources',
    route: '/resources',
    component: <Resources />,
    icon: <Source />,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: 'Admin',
    key: 'admin',
    route: '/admin/users/*',
    icon: <SupervisorAccount />,
    requiresAdmin: true,
    collapse: [
      {
        name: 'User Profile',
        key: 'adminUserProfile',
        route: '/admin/users/:id',
        to: '/admin/users',
        component: <ShowUser />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
        noDisplay: true,
      },
      {
        name: 'Users',
        key: 'adminUsers',
        route: '/admin/users',
        to: '/admin/users',
        component: <UsersList />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
      },
      {
        name: 'Admin Inputs',
        key: 'adminAdminInputs',
        route: '/admin/admin-inputs/*',
        to: '/admin/admin-inputs',
        component: <MasterInputs />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
      },
      {
        name: 'User Analytics',
        key: 'adminUsersAnalytics',
        route: '/admin/userAnalytics',
        to: '/admin/userAnalytics',
        component: <UserAudit />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
      },
      {
        name: 'Data Cleanup',
        key: 'adminDataCleanup',
        route: '/admin/dataCleanup',
        to: '/admin/dataCleanup',
        component: <LeadsList />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
      },
      // {
      //   name: 'DesignReference',
      //   key: 'adminDesignReference',
      //   route: '/admin/designreference/*',
      //   to: '/admin/designreference',
      //   component: <DesignReference />,
      //   icon: <SupervisorAccount />,
      // },
      {
        name: 'New Components',
        key: 'adminNewComponents',
        route: '/admin/new-components/*',
        to: '/admin/new-components',
        component: <NewComponentReference />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
      },
      {
        name: 'Graphs Check',
        key: 'GraphsCheck',
        route: '/admin/graphs-check/*',
        to: '/admin/graphs-check',
        component: <GraphsCheck />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
      },
      {
        name: 'FFCreator',
        key: 'FFCreator',
        route: '/admin/financial-framework-creator/*',
        to: '/admin/financial-framework-creator',
        component: <FinancialFrameworkCreator />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
      },
      {
        name: 'Calculations',
        key: 'adminCalculations',
        route: '/admin/calculations/*',
        to: '/admin/calculations',
        component: <Calculations />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
      },
      {
        name: 'Old Dashboard Design',
        key: 'adminOldDashboard',
        route: '/admin/old-dashboard/*',
        to: '/admin/old-dashboard',
        component: <DashboardTwo />,
        icon: <SupervisorAccount />,
        requiresAdmin: true,
      },
      // {
      //   name: 'New TSP Design',
      //   key: 'adminNewTSP',
      //   route: '/admin/new-tsp/*',
      //   to: '/admin/new-tsp',
      //   component: <NewTsp />,
      //   icon: <SupervisorAccount />,
      //   requiresAdmin: true,
      // },
      // {
      //   name: 'New Profile Design',
      //   key: 'adminNewProfile',
      //   route: '/admin/new-profile/*',
      //   to: '/admin/new-profile',
      //   component: <NewProfile />,
      //   icon: <SupervisorAccount />,
      //   requiresAdmin: true,
      // },
      // {
      //   name: 'New Documents Design',
      //   key: 'adminNewDocuments',
      //   route: '/admin/new-documents/*',
      //   to: '/admin/new-documents',
      //   component: <NewDocuments />,
      //   icon: <SupervisorAccount />,
      //   requiresAdmin: true,
      // },
      // {
      //   name: 'New Benefits Design',
      //   key: 'adminNewBenefits',
      //   route: '/admin/new-benefits/*',
      //   to: '/admin/new-benefits',
      //   component: <NewBenefits />,
      //   icon: <SupervisorAccount />,
      //   requiresAdmin: true,
      // },
      // {
      //   name: 'New TSP Design',
      //   key: 'adminNewTSP',
      //   route: '/admin/new-tsp/*',
      //   to: '/admin/new-tsp',
      //   component: <NewTsp />,
      //   icon: <SupervisorAccount />,
      //   requiresAdmin: true,
      // },
      // {
      //   name: 'New Life Insurance Design',
      //   key: 'adminNewLifeInsurance',
      //   route: '/admin/new-life-insurance/*',
      //   to: '/admin/new-life-insurance',
      //   component: <NewFegli />,
      //   icon: <SupervisorAccount />,
      //   requiresAdmin: true,
      // },
      // {
      //   name: 'New Resources Design',
      //   key: 'adminNewResources',
      //   route: '/admin/new-resources/*',
      //   to: '/admin/new-resources',
      //   component: <Resources />,
      //   icon: <SupervisorAccount />,
      //   requiresAdmin: true,
      // },
    ],
  },
  // {
  //   type: 'collapse',
  //   name: 'Agency',
  //   key: 'agency',
  //   route: '/agency/users/*',
  //   icon: <AccountBox />,
  //   requiresAdmin: true,
  //   collapse: [
  //     {
  //       name: 'Users',
  //       key: 'agencyUsers',
  //       route: '/agency/users',
  //       to: '/agency/users',
  //       component: <AgencyList />,
  //       icon: <SupervisorAccount />,
  //       requiresAdmin: true,
  //     },
  //     {
  //       name: 'Files',
  //       key: 'files',
  //       route: '/agency/files',
  //       to: '/agency/files',
  //       component: <Documents />,
  //       icon: <Article />,
  //       requiresAdmin: true,
  //     },
  //   ],
  // },
]

export default routes
